import { Injectable } from '@angular/core';
import { AuthStore } from '@store';

import { VitoguideBackendSettingsApi } from '@vi-iot/client';
import { BaseApiPickerImpl } from '../base.api-picker';
import { VitoguideBackendSettingsMockApi } from './vitoguide-backend-settings.mock-api';

@Injectable({ providedIn: 'root' })
export class VitoguideBackendSettingsApiPicker extends BaseApiPickerImpl<
  VitoguideBackendSettingsApi | VitoguideBackendSettingsMockApi
> {
  constructor(
    authStore: AuthStore,
    realApi: VitoguideBackendSettingsApi,
    mockApi: VitoguideBackendSettingsMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
